import CustomersNavigation from '~/components/customers-navigation'
import { vueReady } from '~/core/runners'

vueReady(() => {
  CustomersNavigation().init()
})
